import { useSelector } from 'react-redux'
import { useEffect } from 'react'

import { getIsFeatureSwitchEnabled } from 'state/feature-switches/selectors'
import { getIsAbTestOn } from 'state/ab-tests/selectors'

import AdManager from 'libs/common/ad-manager'

import { AdPlatform } from 'constants/ads'

import { Screen } from 'constants/tracking/screens'

import { getScreenName } from 'state/screen/selectors'

import useAbTest from 'hooks/useAbTest/useAbTest'

import Google from '../../setups/Google'
import Pubstack from '../../setups/Pubstack'
import Amazon from '../../setups/Amazon'
import Prebid from '../../setups/Prebid'
import SmartAdServer from '../../setups/SmartAdServer'
import Yieldbird from '../../setups/Yieldbird'
import Confiant from '../../setups/Confiant'
import Rokt from '../../setups/Rokt'
import Blockthrough from '../../setups/Blockthrough'

const RtbSetup = () => {
  const isSmartAdServerEnabled = useSelector(getIsFeatureSwitchEnabled('web_smart_adserver'))

  const isYieldBirdScriptEnabled = useSelector(
    getIsFeatureSwitchEnabled('web_ads_yieldbird_script'),
  )

  const isRoktScriptEnabled = useSelector(getIsFeatureSwitchEnabled('web_ads_rokt_script'))
  const isRoktAbTestEnabled = useSelector(getIsAbTestOn('web_ads_rokt'))
  const isRoktEnabled = isRoktScriptEnabled && isRoktAbTestEnabled

  const screenName = useSelector(getScreenName)
  const isBlockthroughScriptEnabled = useSelector(
    getIsFeatureSwitchEnabled('web_ads_blockthrough_script'),
  )
  const isAdsPlatformWeb = AdManager.getAdsPlatform() === AdPlatform.Web
  const isBlockthroughAbTestPage = [
    Screen.ConversationList,
    Screen.ConversationNew,
    Screen.ConversationReply,
    Screen.Catalog,
    Screen.Item,
  ].includes(screenName)
  const isBlockthroughAbTestEnabled =
    isBlockthroughScriptEnabled && isAdsPlatformWeb && isBlockthroughAbTestPage
  const adblockMonetisationAbTest = useAbTest({
    abTestName: 'web_adblock_monetisation',
    shouldTrackExpose: isBlockthroughAbTestEnabled,
  })
  const isBlockthroughFeatureEnabled =
    isBlockthroughAbTestEnabled && adblockMonetisationAbTest?.variant !== 'off'

  useEffect(() => {
    window.adPlacements = {}
  }, [])

  return (
    <>
      <Google />
      <Pubstack />
      <Amazon />
      <Prebid />
      {isSmartAdServerEnabled && <SmartAdServer />}
      {isYieldBirdScriptEnabled && <Yieldbird />}
      {/*
        TODO: Cover Rokt part in unit tests
        When scaling web_ads_rokt (AB test)
        And/or web_ads_rokt_script (Feature switch)
      */}
      {isRoktEnabled && <Rokt />}
      {/*
        TODO: Cover Blockthrough part in unit tests
        When scaling web_adblock_monetisation (AB test)
        And/or web_blockthrough_ads_script (Feature switch)
      */}
      {isBlockthroughFeatureEnabled && <Blockthrough />}
      <Confiant />
    </>
  )
}

export default RtbSetup
